import React, { useState } from "react";
import { Resizable } from "react-resizable";
import "react-resizable/css/styles.css";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { debounce } from "lodash";
import { externalUsers } from "../../constants/userTypes";
import { useLanguage } from "../../languageContext";
import translations from "../../translation.json";
import { findPathsToValue } from "../../GetPath";

function DraggableHeaderCell({ column, onResize, isDarkMode,type }) {
  const userType = localStorage.getItem("userType");
  const [isResizing, setIsResizing] = useState(false); // Track resizing state
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: column.id });
  const restrictedUserTypesForEvent = ["Agent", "Animator", "Manager"];
  const restrictedUserTypesForNonEvent = ["Agent"];
  
  const canDrag =
    userType &&
    ((type === "event" && !restrictedUserTypesForEvent.includes(userType)) ||
     (type !== "event" && !restrictedUserTypesForNonEvent.includes(userType)));

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };
  const { language } = useLanguage();

  const FindPath = (content, language) => {
    // Step 1: Find the full path for the given content
    const fullPath = findPathsToValue(translations, content)?.[0];
    // console.log("Full Path:", fullPath);  // Log the full path
  
    if (!fullPath) {
      // console.error(`No path found for content: ${content}`);
      return content;
    }
  
    // Step 2: Remove the last segment of the path to get the base path
    const trimmedPathArray = fullPath.split('.').slice(0, -1);
    const basePath = trimmedPathArray.join('.'); // Base path without the last segment
    // console.log("Base Path:", basePath);  // Log the base path
  
    // Step 3: Access the translation dynamically using reduce
    const translation = basePath
      .split('.')   // Split basePath into an array of keys
      .reduce((obj, key) => (obj && obj[key] ? obj[key] : undefined), translations);
  
    // Check if the translation exists for the provided language
    const result = translation ? translation[language] : undefined;
  
    // console.log("Translation Found:", result);
  
    if (!result) {
      // console.error(`No translation found at path: ${basePath} for language: ${language}`);
      return content;
    }
  
    return result;
  };
  // Debounced function to call after resizing stops
  const debouncedResizeStop = debounce(() => {
    setIsResizing(false);
  }, 300); // Adjust delay as needed

  return (
   <Resizable
  width={column.width}
  height={0}
  onResizeStart={() => setIsResizing(true)}
  onResizeStop={() => debouncedResizeStop()}
  onResize={(e, { size }) => onResize(column.id, size.width)}
  draggableOpts={{ enableUserSelectHack: false }}
  handle={
    <div
      className={`resize-handle ${isDarkMode ? "dark" : "light"}`}
      style={{
        position: "absolute",
        right: 0,
        top: 0,
        bottom: 0,
        width: "8px",
        cursor: canDrag ? "col-resize" : "text",
        zIndex: 1,
      }}
      onClick={(e) => e.stopPropagation()}
    />
  }
>
  <th
    className={`${isDarkMode ? "darkthead" : ""} ${column.className || ""}`}
    colSpan={column.colSpan}
    scope="col"
    id={column.id}
    style={{
      ...style,
      width: column.width,
      minWidth:  `${column.width + (column.id === "animator" ? 170 : 50)}px`,
      maxWidth:  `${column.width + (column.id === "animator" ? 200 : 100)}px`,
      cursor: isResizing ? "col-resize" : canDrag ? "move" : "default",
      position: "relative",
      paddingInline: "50px !important",
      marginInline: "4px !important",
    }}
  >
    <div
      className="column-content"
      ref={setNodeRef}
      {...(canDrag && !isResizing ? { ...attributes, ...listeners } : {})}
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <span
        className={`column-title p-2 ${isDarkMode ? "darkthead" : ""} ${column.className || ""}`}
        style={{
          userSelect: "none",
          cursor: canDrag ? "move" : "text",
        }}
      >
        {FindPath(column.content, language)}
      </span>

      {canDrag && (
        <div
          className="custom-resize-handle"
          style={{
            width: "6px",
            height: "100%",
            cursor: "col-resize",
            position: "absolute",
            right: "0",
            top: "0",
            bottom: "0",
            backgroundColor: "#435574",
          }}
          onMouseDown={(e) => e.stopPropagation()}
        />
      )}
    </div>
  </th>
</Resizable>
  );
}

export default DraggableHeaderCell;
